<script lang="ts">
  import EmployerDetail from '../../components/employee/employer/EmployerDetail.svelte';
  import { location } from 'svelte-spa-router';

  function idFromViewEmployerPath(loc: string): string {
    const path = loc.split('?')[0];
    const prefix = '/view-employer/';
    if (!path.startsWith(prefix)) return '';
    return path.slice(prefix.length).split('/')[0] || '';
  }

  // Derive from the URL — more reliable than $params on browser back/forward.
  $: employerId = idFromViewEmployerPath($location);
</script>

{#key employerId}
  <EmployerDetail {employerId} />
{/key}
